import OBTCheckBox2 from './OBTCheckBox2';
export default OBTCheckBox2;
